module.exports = "/public/images/200bd72f955e7e324d18593db8bb9a15.jpg";